// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__2YX4z","summary":"CartItem_summary__2DlIY","price":"CartItem_price__2RyUV","amount":"CartItem_amount__2RE2L","actions":"CartItem_actions__1ehP_"};